<template>
	<div id="app">
		<div>
			<navbar></navbar>
		</div>
		<router-view />
		<cross-domain></cross-domain>
	</div>
</template>

<script>
	import navbar from "@/components/navigation/nav.vue";
	export default {
		components: {
			navbar,
		},
		mounted() {
		}
	}
</script>

<style>
</style>
